import { HTTP } from './helpers/http.js'
export default {
  getOrganizationStructure(organizationId) {
    const url = `/api/v1/organizations/${organizationId}/structure`
    return HTTP.get(url)
  },

  getOrganizationCategories(organizationId) {
    const url = `/api/v1/organizations/${organizationId}/categories`
    return HTTP.get(url)
  },
}
